import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { TextWrapper, TopLine, Heading } from "./FAQ.elements";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "1fr",
    gap: "10px",

    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 150,
    backgroundColor: "black",
    position: "relative",
    margin: "auto",
  },
  acc: {
    backgroundColor: "#000517",
    color: "white",
    border: "1px solid darkblue",
    margin: "auto",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    color: "#25AAE1",
  },
}));

const FAQ = ({ data }) => {
  const classes = useStyles();
  const matches = useMediaQuery("(max-width:768px)");
  const matches1 = useMediaQuery("(max-width:960px)");

  return (
    <>
      <div className={classes.root}>
        <TextWrapper
          style={
            matches1
              ? { margin: "20px", paddingBottom: "5px", paddingTop: "0px" }
              : {
                  paddingRight: "15px",
                  paddingLeft: "15px",
                  flex: 1,
                  margin: "0 15px 15px 15px",
                  maxWidht: "50%",
                  flexBasis: "50%",
                }
          }
        ></TextWrapper>
        <Heading lightText="true">FAQs</Heading>
        <TopLine lightTopLine="true">Frequently answered Questions</TopLine>

        {data.map((faq) => {
          return (
            <Accordion
              className={classes.acc}
              style={{ width: `${matches ? "95%" : "65%"}` }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon style={{ color: "#25AAE1" }} />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography className={classes.heading}>{faq.q}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{faq.ans}</Typography>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    </>
  );
};

export default FAQ;
